import get from 'lodash/get';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import APIUtils from '@spothero/utils/api';
import GTMUtils from 'utils/gtm';
import ContentAPI from 'api/content';
import SegmentUtils from 'utils/segment';
import SHUtils from 'utils/sh-utils';
import Card from 'common/card/Card';
import Promo from 'common/promo/Promo';
import LookBookPark from './LookBookPark';
import HomeHero from './HomeHero';
import HomeAppPromo from './HomeAppPromo';
import {Helmet} from 'react-helmet';

export class Home extends Component {
    static propTypes = {
        email: PropTypes.string,
        referrer: PropTypes.string,
        referrerAffiliate: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        serverContext: PropTypes.object,
    };

    constructor(props) {
        super(props);

        const {serverContext} = props;
        let newState = {
            isLoaded: false,
            heroTitle: null,
            horizontalPromos: null,
            verticalPromos: null,
        };

        // if this route was the initial load and data exists from the server already, use it
        if (get(serverContext, 'initialRouteData')) {
            newState = {
                ...serverContext.initialRouteData,
                isLoaded: true,
            };
        }

        this.state = newState;
    }

    componentDidMount() {
        const {referrer, referrerAffiliate} = this.props;
        const {isLoaded} = this.state;

        if (!isLoaded) {
            this._loadData();
        }

        SegmentUtils.page({
            name: 'Web Landing',
            properties: {
                referrer: referrer || document.referrer,
                'referrer affiliate': referrerAffiliate,
            },
        });

        GTMUtils.push({
            event: 'pageview',
            page: 'home',
        });

        SHUtils.staticScrollTo();
    }

    componentWillUnmount() {
        if (this._dataLoader) {
            this._dataLoader.cancel();
            this._dataLoader = null;
        }
    }

    async _loadData() {
        let newState = {
            isLoaded: true,
        };

        try {
            this._dataLoader = APIUtils.makeCancelable(
                ContentAPI.getHomepage()
            );

            const {
                data: {data},
            } = await this._dataLoader.promise;

            newState = {
                ...newState,
                ...data,
            };
        } catch (error) {
            console.log('Error loading homepage data: ', error); // eslint-disable-line no-console
        }

        if (this._dataLoader) {
            this.setState(newState);
        }

        this._dataLoader = null;
    }

    render() {
        const {email} = this.props;
        const {isLoaded, heroTitle} = this.state;
        const promoTypes = ['horizontal', 'vertical']
            .map(orientation => {
                const promos = this.state[`${orientation}Promos`];

                return promos ? {orientation, promos} : null;
            })
            .filter(Boolean);

        return (
            <div className="Home">
                <Helmet>
                    <link rel="canonical" href="https://spothero.com" />
                </Helmet>
                <HomeHero title={heroTitle} />
                <div className="Home-content">
                    <section className="Home-container">
                        <LookBookPark />
                    </section>
                    {isLoaded && Boolean(promoTypes.length) && (
                        <section className="Home-container Home-promos-container">
                            {promoTypes.map(({orientation, promos}) => (
                                <div
                                    className={`Home-cards Home-cards-${orientation}`}
                                    key={orientation}
                                >
                                    {get(promos, 'title') && (
                                        <h1 className="Home-heading">
                                            {promos.title}
                                        </h1>
                                    )}
                                    {promos.cards.map((card, index) => (
                                        <Card key={index} noPadding>
                                            <Promo
                                                orientation={orientation}
                                                imageId={`homepage/${card.imageId}`}
                                                imagePosition={
                                                    card.imagePosition
                                                }
                                                title={card.title}
                                                content={card.description}
                                                buttonText={card.buttonText}
                                                buttonLink={card.url}
                                                links={card.links}
                                            />
                                        </Card>
                                    ))}
                                </div>
                            ))}
                        </section>
                    )}
                    <section className="Home-container Home-apps-container">
                        <HomeAppPromo email={email} />
                    </section>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        user: {
            data: {email},
        },
        search: {
            data: {referrer, referrerAffiliate},
        },
    } = state;

    return {
        email,
        referrer,
        referrerAffiliate,
    };
};

export default connect(mapStateToProps)(Home);
